import React from 'react';
import { Modal, Box, Typography, Button } from '@mui/material';

const ConfirmationDialog = ({ open, onClose, onConfirm }) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="confirmation-dialog-title"
      aria-describedby="confirmation-dialog-description"
    >
      <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: 300, bgcolor: 'background.paper', boxShadow: 24, p: 4 }}>
        <Typography id="confirmation-dialog-title" variant="h6" component="h2">
          Confirmation
        </Typography>
        <Typography id="confirmation-dialog-description" sx={{ mt: 2 }}>
          Vous avez des modifications non sauvegardées. Voulez-vous vraiment changer d'enfant ?
        </Typography>
        <Box sx={{ mt: 2 }}>
          <Button variant="contained" color="primary" onClick={onConfirm}>
            Oui
          </Button>
          <Button variant="outlined" color="secondary" onClick={onClose} sx={{ ml: 2 }}>
            Non
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default ConfirmationDialog;
